import {gql} from "@apollo/client";
import { client } from "graphql/client";

// 创建客服跟单角色
export const CREATE_ACCOUNT_CS_FOLLOW_UP = gql`
    mutation CreateAccountCSFollowUp($input: AccountCSFollowUpInput!) {
        createAccountCSFollowUp(input: $input)
    }
`;

// 更新客服跟单角色
export const UPDATE_ACCOUNT_CS_FOLLOW_UP = gql`
    mutation UpdateAccountCSFollowUp($input: AccountCSFollowUpInput!) {
        updateAccountCSFollowUp(input: $input)
    }
`;

export interface AccountCSFollowUpInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    role: string;
}

export const createAccountCSFollowUp = async (input: AccountCSFollowUpInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: CREATE_ACCOUNT_CS_FOLLOW_UP,
        variables: {input}
    });
    return data.createAccountCSFollowUp;
};

export const updateAccountCSFollowUp = async (input: AccountCSFollowUpInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_CS_FOLLOW_UP,
        variables: {input}
    });
    return data.updateAccountCSFollowUp;
};

